<template>
  <nav :class="navClass">
    <div class="nav-inner" @mouseleave="handleMouseOut">
      <h1 class="logo"  @click="routerpush('/')" style="cursor: pointer">
        <img :src="require('../assets/img/rebit_logo_noBG.png')" alt=""/>
        <span v-if="devEnv">DEV</span>
      </h1>
      <div class="menu-box">
        <ul class="menu" :class="{ ja: Language == 'ja' }">
          <div class="menu-item-wrapper" v-for="(v, i) of menuList" :key="i">
            <li class="menu-item" :class="{ active: activeMenuIndex == i }" @click="routerpush(v.src)">
              <span href="#">{{ v.name }}</span>
            </li>
          </div>
        </ul>
      </div>
      <div class="right-row">
        <div class="login_btn" v-if="!login">
          <el-button plain style="margin-right:12px;" @click="$router.push({name:'login'})">{{ $t("lang.Login") }}</el-button>
        </div>

        <el-dropdown @command="handlePlatformDropdown" v-if="login" :disabled = disablePltBtn>
          <el-button class="platform_btn" plain :disabled = disablePltBtn>
            {{ selectedPlatform.fullName }}
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(v, index) in platforms" :key="'item_' + index" :command="v.shortName" class="nft-drop-item" >
              <img class="nft-drop-img" :src="v.icon ? BASE_GLOB_API()+v.icon : '../assets/img/ETH.png'">
              {{ v.fullName }}
            </el-dropdown-item>
            <el-dropdown-item divided>
              1 ETH = {{cfxRate}} CFX
            </el-dropdown-item>
            <el-dropdown-item divided>
              1 ETH = {{btyRate}} BTY
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown @command="handleDropdown">
          <el-button class="personal_btn" plain>
            <i class="el-icon-user"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :disabled = "!login" command="personal">{{ $t("lang.dashboard") }}</el-dropdown-item>
            <el-dropdown-item :disabled = "!login" command="mine">{{ $t("lang.mine") }}</el-dropdown-item>
            <el-dropdown-item :disabled = "!login" command="new">{{ $t("lang.create") }}</el-dropdown-item>
            <el-dropdown-item divided command="opendoc">{{ $t("lang.doc") }}</el-dropdown-item>
            <el-dropdown-item command="openinstall">{{ $t("lang.install") }}</el-dropdown-item>
            <el-dropdown-item :disabled = "!login" divided command="logout">{{ $t("lang.logout") }}</el-dropdown-item>
            <el-dropdown-item divided command="lan_en">English</el-dropdown-item>
            <el-dropdown-item command="lan_ja">日本語</el-dropdown-item>
            <el-dropdown-item command="lan_ko">한국어</el-dropdown-item>
            <el-dropdown-item command="lan_cn">繁體中文</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        </div>
      </div>
  </nav>
</template>
<script>
import util from "../lib/util.js";
import ad from "../utils/web3Helper.js";
import downMenu from "./downMenu.vue";
import {doc,BASE_GLOB_API,install} from "@/config.js"
import request from "../services/request";
import {axiosGet} from "@/api/api";
import EventBus from "@/utils/EventBus";
import {isPc} from "@/utils";
import {getChainProperty} from "@/lib/multiChain";
export default {
  props: {
    activeMenuIndex: {
      type: String,
      default: "0",
    },
    disablePltBtn: {
      type: Boolean,
      default: true,
    },
  },
  components: { downMenu },
  data() {
    return {
      devEnv: false,
      cfxRate: 0,
      btyRate: 0,
      showAnnouncement: false, // Controls the announcement visibility TODO fix always show bug
      accountShot: "",
      expand: false,
      scrollDirection: "down",
      pageScroll: 0,
      Language: "en",
      active: false,
      address: "",
      avatar:'',
      api:BASE_GLOB_API,
      login:false,
      platforms:[],
      selectedPlatform: {},
      url: {
        platform:BASE_GLOB_API+'/kanban/coin/platform',
      },
    };
  },
  watch: {
    "$store.state.ShowDownMenu"(val, oldVal) {
      if (val == 3) {
        this.active = false;
      }
    },
  },
  computed: {
    token() {
      return localStorage.getItem("Token") ? true:false ;
    },
    account() {
      let address = this.$store.getters.address;
      if (address) {
        return (
          address.substr(0, 5) + "...." + address.substr(address.length - 4, 4)
        );
      } else {
        return false;
      }
    },
    menuList() {
      return [
        {
          name: this.$t("lang.home"),
          src: "/",
        },
        {
          name: this.$t("lang.ranking"),
          src: "/ranking",
        },
        {
          name: this.$t("lang.opting"),
          src: "/pickMarket",
        },
        {
          name: this.$t("lang.market"),
          src: "/tradingMarket",
        },
        {
          name: this.$t("lang.mine"),
          src: "/mine",
        },
      ];
    },
    navClass() {
      return this.pageScroll > 0 ? 'white-nav' : 'transparent-nav';
      // return this.pageScroll > 0 ? 'white-nav' : 'transparent-nav';
      // if (this.pageScroll < 30) {
      //   if (this.expand) {
      //     return "white-nav white-nav-expand";
      //   } else {
      //     return "transparent-nav";
      //   }
      // } else if (this.pageScroll >= 30 && this.pageScroll < 50) {
      //   return "white-nav";
      // } else {
      //   if (this.scrollDirection === "down") {
      //     this.active = false;
      //     return "white-nav hide-nav";
      //   } else {
      //     return "white-nav";
      //   }
      // }
     },
  },
  created() {
    const backend_env = (process.env.VUE_APP_SERVER_ENV || 'prod').trim();
    if (backend_env === 'dev'){
      this.devEnv = true;
    }


    let lang = sessionStorage.getItem("Language");
    if (lang) {
      this.Language = lang;
    }
    let token = localStorage.getItem("Token");
    if(token){
      this.login =true;
      this.userinfo =JSON.parse(sessionStorage.getItem("userinfo")) ;
      this.getBtPlatform()
      request.getCfxRate().then(res=>{
        if(res.code == 200){
          this.cfxRate = res.result;
          sessionStorage.setItem("cfxRate", this.cfxRate);
          console.log("cfxRate",this.cfxRate)
        }else{
          // this.$message.error("cfxRate error");
        }
      })
      request.getBtyRate().then(res=>{
        if(res.code == 200){
          this.btyRate = res.result;
          sessionStorage.setItem("btyRate", this.btyRate);
          console.log("btyRate",this.btyRate)
        }else{
          // this.$message.error("cfxRate error");
        }
      })
      // if (this.devEnv) {
      //   this.cfxRate = 23456;
      //   sessionStorage.setItem("cfxRate", this.cfxRate);
      // }
     if(this.userinfo.avatar){
      this.avatar =this.api + this.userinfo.avatar
       console.log("avatar",this.avatar)
     }else{
      this.avatar = null
     }
    }else{
      this.$message.error(this.$t("lang.loginTip"));
      this.routerpush({name:'login'});
      this.login =false
    }
    window.addEventListener("scroll", this.handleScroll);
    ad.init()

  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    BASE_GLOB_API() {
      return BASE_GLOB_API
    },
    goToAnnouncement() {
      this.$router.push("/ranking");
    },
    Logout(){
      this.$router.push({name:'login'});
      window.sessionStorage.clear();
      window.localStorage.clear();

    },
    command(v) {
      if (v == "Tasks") {
        this.$router.push({
          name: "task",
        });
      } else if (v == "Ranking") {
        this.$router.push({
          name: "rank",
        });
      } else {
        sessionStorage.setItem("scroll", "true");
        this.$router.push({
          name: "personal",
        });
      }
    },
    handleMouseOut() {
      // this.active = false;
    },
    handleDropdown(command) {
      switch (command) {
        case "personal":
          this.$router.push({ name: "center" });
          break;
        case "mine":
          this.$router.push({ name: "mine" });
          break;
        case "new":
          this.$router.push({ name: "homeIndex" });
          break;
        case "opendoc":
          this.open();
          break;
        case "openinstall":
          this.install();
          break;
        case "logout":
          this.Logout();
          break;
        case "lan_en":
          this.handleChangeV2("en");
          break;
        case "lan_ja":
          this.handleChangeV2("ja");
          break;
        case "lan_ko":
          this.handleChangeV2("ko");
          break;
        case "lan_cn":
          this.handleChangeV2("cn");
          break;
        default:
          break;
      }
    },
    handlePlatformDropdown(command) {
      console.log("handlePlatformDropdown command",command)
      this.platforms.forEach(item=>{
        if(item.shortName === command){
          let selectedPlatform = {
            enabled:item.enabled,
            fullName:item.fullName,
            icon:item.icon,
            id:item.id,
            shortName:item.shortName,
            unit:item.unit,
          }

          window.sessionStorage.setItem("selectedPlatform", JSON.stringify(getChainProperty(selectedPlatform)));
          this.selectedPlatform = JSON.parse( sessionStorage.getItem("selectedPlatform"));
          this.$emit("platform");
          document.title = "Rebit · " + this.selectedPlatform.fullName;
        }
      });
    },
    getBtPlatform() {
      let cache = localStorage.getItem("platFormData");
      let useCache = false;
      if (cache) {
        try {
          cache = JSON.parse(cache);
          // 判断缓存是否过期
          if (Date.now() - cache.time < 24 * 60 * 60 * 1000) {
            useCache = true;
            this.handlePlatformData(cache.data);
            return;
          }
        } catch (e) {
          // 解析失败则不使用缓存
        }
      }
      axiosGet(this.url.platform).then(res=>{
        if(res.code ==200){
          let data =res.result
          console.log("platFormData",data)
          localStorage.setItem(
              "platFormData",
              JSON.stringify({
                time: Date.now(),
                data: res.result
              })
          );
          this.handlePlatformData(data);
        }else{
          this.$message.error(res.message);
        }
      })
    },
    handlePlatformData(date) {
      this.platforms = []
      if(date.length > 0){
        date.forEach(item=>{
          if(item.enabled && item.fullName !=="Revolution" && item.isHiddenUserUi !== true){
            let source ={
              enabled:item.enabled,
              fullName:item.fullName,
              icon:item.icon,
              id:item.id,
              shortName:item.shortName,
              unit:item.unit,
              networkVos:item.networkVos,
            }
            this.platforms.push(source)
          }
        });

        let selectedPlatform = JSON.parse( sessionStorage.getItem("selectedPlatform"));
        if(selectedPlatform){
          console.log("selectedPlatform",selectedPlatform);
          // this.value =selectedPlatform.btPlatformId
          this.platforms.forEach(item=>{
            if(item.id === selectedPlatform.btPlatformId){
              let selectedPlatformNew = {
                enabled:item.enabled,
                fullName:item.fullName,
                icon:item.icon,
                id:item.id,
                shortName:item.shortName,
                unit:item.unit,
                networkVos:item.networkVos,
              }
              console.log("selected",selectedPlatformNew)
              window.sessionStorage.setItem("selectedPlatform", JSON.stringify(getChainProperty(selectedPlatformNew)));
            }

          });
        }else{
          let selectedNetPc = {
            enabled:this.platforms[0].enabled,
            fullName:this.platforms[0].fullName,
            icon:this.platforms[0].icon,
            id:this.platforms[0].id,
            shortName:this.platforms[0].shortName,
            unit:this.platforms[0].unit,
            networkVos:this.platforms[0].networkVos,
          }
          window.sessionStorage.setItem("selectedPlatform", JSON.stringify(getChainProperty(selectedNetPc)));
        }
      }
      sessionStorage.setItem("platforms", JSON.stringify(this.platforms));
      this.selectedPlatform = JSON.parse( sessionStorage.getItem("selectedPlatform"));
      document.title = "Rebit · " + this.selectedPlatform.fullName;
      this.$emit("Platform", this.selectedPlatform);
    },
    handleShow() {
      let token = this.getStorageToken();
      // console.log(token)
      if (!token) {
        sessionStorage.setItem("iSsignature", false);
        this.getSign();
      } else {
        this.$refs.downMenu.account = this.address;
        this.$refs.downMenu.getList();
        this.active = !this.active;
        if (this.active) {
          this.$store.commit("SetShowDownMenu", 1);
        }
      }
    },
    open() {
      window.open(doc);
    },
    install() {
      window.open(install);
    },

    handleChange() {
      this.$i18n.locale = this.Language;
      sessionStorage.setItem("Language", this.Language);
    },
    handleChangeV2(lan) {
      this.Language = lan;
      this.handleChange();
    },
    connectX() {
      //没有安装小狐狸
      // if (!window.ethereum || this.address=='') {
      //   return this.$refs.showMetamask.show=true;
      // }
      // this.$refs.showMetamask.show=true;

    },
    routerpush(to) {
      this.$router.push(to);
      // document.getElementById('active')
      // 跳转之后，记得关闭菜单（在屏幕宽度小于800的时候才生效）
    },
    handleScroll() {
      this.pageScroll = window.scrollY;
      // window.addEventListener("scroll", (event) => {
      //   let scrollTop = util.getPageScrollY();
      //   if (scrollTop > this.pageScroll) {
      //     this.scrollDirection = "down";
      //   } else {
      //     this.scrollDirection = "up";
      //   }
      //
      //   this.pageScroll = scrollTop;
      // });
    },
  },
};
</script>
<style lang="less" scoped>
nav {
  position: fixed;
  top: 0;
  left: 0px;
  width: 100%;
  z-index: 999;
  width: 100%;
  height: 70px;
  transition: all 0.4s;
  min-width: 1000px;
}
.announcement-popup {
  position: absolute;
  top: 80px; /* Positioned below the navbar */
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 50, 150, 0.95); /* Themed background */
  color: white;
  padding: 15px 25px;
  border-radius: 10px;
  text-align: center;
  width: 400px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}
.announcement-popup p {
  font-size: 16px;
  margin-bottom: 10px;
}
.announcement-buttons {
  display: flex;
  justify-content: space-between;
}
.btn-more, .btn-dismiss {
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}
.btn-more {
  background: #007bff;
  color: white;
}
.btn-more:hover {
  background: #0056b3;
}
.btn-dismiss {
  background: #ff4d4d;
  color: white;
}
.btn-dismiss:hover {
  background: #cc0000;
}
.lang {
  width: 113px;
  margin-right: 20px;
  margin-bottom: 10px;
  .el-select {
    width: 100%;
    /deep/ .el-input__inner {
      background: transparent;
      color: #333;
      padding-right: 30px;
      height: 36px;
      border-color: #ccc;
    }
  }
}
.nav-inner {
  width: 100%;
  height: 100%;
  margin: 0px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 99;
  min-width: 900px;
  //Background-color: #841ae9;//TODO remove this
  align-items: flex-end;

  .logo {

    position: relative;
    height: 70px;
    margin-left: 20px;
    top: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 220px;
    padding-right: 20px;

    img {
      max-width: 200px;
      max-height: 70px;
      width: auto;
      height: auto;
    }
  }
  .menu-box {
    position: relative;
    width: 100%;
    //background-color: #7d6fff;//TODO remove this
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .menu {
      height: 100%;
      margin-top: 3px;
      display: flex;
      //background-color: #9D50BB;//TODO remove this
      width: 100%;
      justify-content: center;
      align-content: center;
      .menu-item-wrapper {
        //background-color: #f82727;//TODO remove this
        display: flex;
        justify-content: center;
        align-content: center;
      }
      .menu-item-wrapper::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        top: 35px;
        background-color: #7d6fff; /* Change the color as needed */
        border-radius: 50%;
        margin-left: 20px;
        margin-right: 20px; /* Adjust the spacing as needed */
        margin-top: 31px;
      }
      .menu-item-wrapper:first-child::before {
        display: none;
      }
      .menu-item {
        //background-color: #FFFFFF;//TODO remove this
        height: 70%;
        top: 15%;
        padding: 0px 10px 0px 10px;
        width: auto;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        position: relative;
        cursor: pointer;
        font-size: 18px;
        color: #17181f;
        border-radius: 30px;
        & > span {
          position: relative;
          align-self: center;
          white-space: nowrap;
          overflow: hidden;
        }
        &.active {
          span {
            color: #17181f;
            font-weight: 600;
          }
        }
        .el-dropdown {
          color: #12022f;
        }
        .el-dropdown .el-dropdown-link {
          display: flex;
          align-items: center;
          i {
            margin-top: 5px;
            font-size: 14px;
          }
        }
      }
      .doc {
        img {
          width: 44px;
          margin-bottom: 3px;
        }
        // i {
        //   color: #000;
        //   font-size: 16px;
        //   margin-left: 4px;
        // }
      }
    }
  }

  .right-row {
    position: relative;
    align-items: flex-end;
    height: 40px;
    margin: auto;
    display: flex;
    gap: 20px;
    margin-right: 30px;
    .downmenu {
      position: absolute;
      top: 50px;
      left: -34%;
      height: 0;
      overflow: hidden;
      z-index: 10000;
      transition: all 0.3s;
      padding-top: 20px;
    }
    .show {
      height: 630px;
    }
  }
}
.ja {
  .menu-item {
    width: 160px;
    padding: 0px 5px 10px;
  }
}
.menu-item:hover {
  span {
    color: #3c4897;
  }
}
.doc:hover {
  span {
    color: #f400ff;
  }
}
// .menu-item:hover > span::after {
//   opacity: 1;
//   transform: scaleX(1);
// }
// .doc:hover > span::after{
//     opacity:0;
// }
.menu-item-trigger {
  width: 100%;
  height: 348px;
  position: absolute;
  top: 100%;
  left: 0px;
  z-index: 1;
}

.nft-drop-item {
  display: flex;
  align-items: center;
}

.nft-drop-img{
  max-width: 24px;
  max-height: 24px;
  width: auto;
  height: auto;
  margin-right: 8px;
}

.lang-box {
  a {
    opacity: 0.7;
  }

  i {
    font-size: 12px;
    opacity: 0.7;
    margin: 0px 3px;
  }

  .current {
    opacity: 1;
  }
}

.white-nav {
  background: #fff;
  .nav-inner{
    //border-bottom: 2px solid #12022f;
  }
  //border-bottom: 1px solid #ccc;
  //.logo {
  //  a {
  //    background-image: url(../assets/img/logo.png);
  //  }
  //}
  .menu-item{
    color: #12022f;
  }
  .menu-item:hover{
    span{
      color: #3c4897;
    }
  }
  .menu-item.active{
    border: 2px solid #3c4897;
    span{
      color: #3c4897;
    }
  }
}

.transparent-nav {
  background-color: transparent;
  .menu-item{
    color: #17181f;
  }
  .menu-item:hover{
    span{
      color: #17181f;
    }
  }
  .menu-item.active{
    border: 2px solid #17181f;
    span{
      color: #17181f;

    }
  }
  .login_btn{
    .el-button{
      color: #17181f;
      border: 2px solid #17181f;
    }
  }

  .personal_btn{
    color: #17181f;
    border: 2px solid #17181f;
  }
}

.white-nav-expand {
  //background-color: transparent;
  background-color: #fff;
}

.hide-nav {
  top: -90px;
}

.account {
  color: #333;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 0 20px;
  .account-info {
    border: #ccc 1px solid;
    border-radius: 2em;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 4.5px 13px;
    cursor: pointer;
    position: relative;
    .account-icon {
      width: 22px;
      height: 22px;
      margin-right: 10px;
    }
    .avatar-default {
      width: 24px;
      margin-top: 1px;
    }
    .nft-avatar {
      .avatar-inner {
        width: 100%;
        height: 100%;
      }
      .avatar-default {
        height: 50%;
      }
    }
    .text {
      text-decoration: underline;
      font-size: 16px;
      line-height: 22px;
      margin-left: 5px;
    }
    .dropdown {
      position: absolute;
      left: -1px;
      right: -1px;
      top: 42px;
      background: rgba(0, 0, 0, 0.5);
      padding: 10px 0;
      border-radius: 0 0 22px 22px;
      border: #979797 1px solid;
      border-top: 0;
      display: none;
      .inner {
        li {
          a {
            display: block;
            padding: 5px 20px;
            font-size: 16px;
            &:hover {
              opacity: 0.6;
            }
          }
        }
      }
    }
  }
}
.activeAccount {
  color: #fff;
  .account-info {
    background: #3c4897;
  }
}
.wallet-connect {
  color: #000;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  width: 175px;
  margin-bottom: 10px;
  .icon {
    background: url("~@/assets/img/wallet.svg") no-repeat center center/50% 50%;
    width: 38px;
    height: 38px;
    margin-right: 5px;
    border-radius: 50%;
  }
  .info {
    font-size: 16px;
    text-decoration: underline;
    line-height: 22px;

  }
  .img{
        width: 32px;
        height: 32px;
        background: #fff;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        // margin-right: 5px;

  }
}

.default-img {
  width: 40px;
  height: 40px;
}

.el-dropdown-link {
  font-size: 20px;
}

.personal_btn{
  background: transparent;
  color: #12022f;
  border: 2px solid #12022f;
  border-radius: 20px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  i{
    font-size: 20px;
  }
}
.platform_btn{
  background: transparent;
  color: #12022f;
  border: 2px solid #12022f;
  border-radius: 20px;
  width: 140px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  i{
    font-size: 20px;
  }
}
.login_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;

  .el-button {

    background: transparent;
    color: #12022f;
    border: 2px solid #12022f;
    border-radius: 20px;
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
</style>
<style lang="less">
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: #efefef;
  color: #12022f;
}
</style>